// RestoMag Events — submit-lead payload envelope (SHARED: client + Edge Function).
// NOTE: consent_version is intentionally NOT accepted from the client — the Edge
// Function stamps the event's current consent_version server-side so it can't be
// spoofed. See docs/ARCHITECTURE.md §8.1.
import { z } from "zod";

/** Normalize a typed/scanned code: uppercase, strip separators, map Crockford confusables. */
export function normalizeCode(raw: string): string {
  return raw
    .toUpperCase()
    .replace(/[\s-]/g, "")
    .replace(/O/g, "0")
    .replace(/[IL]/g, "1");
}

export const SubmitLeadPayloadSchema = z.object({
  event_slug: z.string().regex(/^[a-z0-9](?:[a-z0-9-]{1,61}[a-z0-9])$/),
  field_values: z.record(z.string(), z.unknown()),
  consent_given: z.boolean(),
  marketing_opt_in: z.boolean().default(false),
  turnstile_token: z.string().min(1),
  // Honeypot: must be empty for a real human; non-empty => silent drop.
  honeypot: z.string().optional().default(""),
  source: z.enum(["phone", "kiosk"]).default("phone"),
  // Cap raw input before normalizing, and bound the normalized code, so an attacker
  // can't push a huge string through the redeem RPC.
  code: z.string().max(64).transform(normalizeCode).pipe(z.string().min(1).max(32)),
});
export type SubmitLeadPayload = z.infer<typeof SubmitLeadPayloadSchema>;

/** Stable error codes the Edge Function returns; the client maps these to copy. */
export const SUBMIT_ERROR_CODES = [
  "validation_failed",
  "turnstile_failed",
  "rate_limited",
  "event_closed",
  "duplicate",
  "no_contact",
  "insert_failed",
  "method_not_allowed",
  "code_required",
  "code_invalid",
  "code_already_used",
] as const;
export type SubmitErrorCode = (typeof SUBMIT_ERROR_CODES)[number];
